export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-greek-ext-400-normal.woff2?f2fa0d9ef98f59d4a75b83c3cab1401e";